<template>
  <div :class="$style.ProductSideSwitcher">
    <div
      v-for="{ key: side, src } of $store.getters['product/images']"
      :key="side"
      :class="[
        $style.SideSwitcher,
        {
          [$style['SideSwitcher--active']]:
            side === $store.state.activePrintSide
        }
      ]"
      @click="setCurrentSide(side)"
    >
      <img
        :src="src"
        :alt="translate(side)"
        class="hidden md:block md:float-none"
      />
    </div>
  </div>
</template>

<script>
import { MUTATION_SET_PRINT_SIDE } from '../store/mutation-types';
import { TrackingMixin } from '../mixins/gtm-tracking';
export default {
  name: 'ProductSideSwitcher',
  mixins: [TrackingMixin],
  methods: {
    translate(val) {
      return val ? this.$t(`printSide.${val}`) : '';
    },
    setCurrentSide(side) {
      this.trackEvent({
        action: 'ChangePrintSide',
        label: `${this.$store.state.activePrintSide}_${side}`
      });
      this.$store.commit(MUTATION_SET_PRINT_SIDE, side);
    }
  }
};
</script>

<style
  lang="scss"
  src="../scss/components/ProductSideSwitcher.scss"
  module
></style>
